<nz-page-header *ngIf="!ticket" nzTitle="Loading {{ticketMode}}"></nz-page-header>
<ng-container *ngIf="ticket">
	<div class="row">
		<div class="col">
			<nz-page-header *ngIf="!ticket.id"
				nzTitle="Create {{ticket.workflowLabel}} {{ticketMode}}"></nz-page-header>
			<nz-page-header *ngIf="ticket.id"
				nzTitle="Manage {{ticket.workflowLabel}} {{ticketMode}}"></nz-page-header>
		</div>
		<div class="col-1">
			<a nz-button nzType="dashed" class="mt-3"
				[routerLink]="['/ticket',ticketMode,ticket.workflowId,ticket.currentStepId,'list']">Back</a>
		</div>
	</div>

	<nz-steps nzDirection="horizontal" nzLabelPlacement="vertical" (nzIndexChange)="onStepIndexChange($event)"
		[nzCurrent]="selectedStepIndex">
		<nz-step *ngFor="let step of ticket.steps" [nzTitle]="step.label" [nzSubtitle]="step.description"
			[nzStatus]="getStepStatus(step)" [nzDisabled]="!step.isCurrentState"></nz-step>
	</nz-steps>
</ng-container>



<nz-alert *ngIf="ticket && !ticket.hasAccess" nzType="warning" nzMessage="Read Only"
	nzDescription="You don't have permissions to process this ticket." nzShowIcon class="mb-3">
</nz-alert>

<div *ngIf="ticket">
	<nz-card nzTitle="Details" [nzExtra]="extraTmpl">
		<div class="row" *ngIf="step.details.length > 0">
			<div class="col">
				<div
					*ngFor="let group of getDetailGroups(step);let i=index; trackBy: trackByGroupLabel">
					<h5 [ngClass]="{'mt-4':i>0}">
						{{group.groupLabel}}
					</h5>
					<div class="row">
						<div class="col-3"
							*ngFor="let detail of group.details; trackBy: trackByDto">
							<nz-form-item>
								<nz-form-control>
									<nz-form-label>{{ detail.label
										}}</nz-form-label>
									<nz-form-control>
										<input nz-input
											[placeholder]="detail.label"
											[value]="detail.value"
											readonly />
									</nz-form-control>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>
			</div>
		</div>

		<ng-template #extraTmpl>
			<button *ngIf="ticket.relatedToOtherTicket" nz-button
				(click)="showTicketHistory(ticket.relatedToOtherTicket,'Reported Ticket History')">View
				Reported Ticket Details</button>
			<button *ngIf="ticket.id" nz-button
				(click)="showTicketHistory(ticket,'Tickets History')">Tickets History</button>
		</ng-template>
	</nz-card>
	<nz-card nzTitle="Policy Details" *ngIf="ticket.policySummary">
		<div class="summary-grid" *ngIf="ticket.policySummary">


			<nz-card nzSize="small" nzTitle="Policy">
				<div class="summary-field">
					<span class="summary-field__label">Product </span>
					<span class="summary-field__value">{{ ticket.policy?.product?.name }}: {{
						ticket.policy?.productOffer?.name }}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Policy Number</span>
					<span class="summary-field__value">{{ ticket.policy?.policyNumber }}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Start Date</span>
					<span class="summary-field__value">{{ ticket.policy?.fromDate | date }}</span>
				</div>
				<div class="summary-field" *ngIf="ticket.policy?.toDate">
					<span class="summary-field__label">End Date</span>
					<span class="summary-field__value">{{ ticket.policy?.toDate | date }}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Status</span>
					<span class="summary-field__value">{{ ticket.policy?.status }}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Est. Benefit</span>
					<span class="summary-field__value summary-field__value--highlight">
						{{ ticket.policySummary.estimatedBenefitAmount | currency: 'ZAR' :
						'symbol-narrow' }}
					</span>
				</div>
			</nz-card>

			<nz-card nzSize="small" [nzTitle]="getPolicyPersonPrefix() + ' Person'">
				<div class="summary-field">
					<span class="summary-field__label">Name</span>
					<span class="summary-field__value">{{ ticket.policySummary.claimPerson?.name
						}}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Surname</span>
					<span class="summary-field__value">{{ ticket.policySummary.claimPerson?.surname
						}}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">ID Number</span>
					<span class="summary-field__value">{{ ticket.policySummary.claimPerson?.idNumber
						}}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Relation to principal member</span>
					<span class="summary-field__value">{{
						ticket.policySummary.claimPersonRelationship }}</span>
				</div>
			</nz-card>

			<nz-card nzSize="small" nzTitle="Informant">
				<div class="summary-field">
					<span class="summary-field__label">Name</span>
					<span class="summary-field__value">{{ ticket.policySummary.informantPerson?.name
						}}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Surname</span>
					<span class="summary-field__value">{{
						ticket.policySummary.informantPerson?.surname }}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">ID Number</span>
					<span class="summary-field__value">{{
						ticket.policySummary.informantPerson?.idNumber }}</span>
				</div>
			</nz-card>

			<nz-card nzSize="small" nzTitle="Incident">
				<div class="summary-field">
					<span class="summary-field__label">Date</span>
					<span class="summary-field__value">{{ ticket.policySummary.incidentDate | date
						}}</span>
				</div>
				<div class="summary-field">
					<span class="summary-field__label">Type</span>
					<span class="summary-field__value">{{ ticket.policySummary.incidentType
						}}</span>
				</div>
			</nz-card>

		</div>
		<div class="row">
			<div class="col">
				<h5>Beneficiaries</h5>
				<nz-table [nzSize]="'small'" [nzData]="ticket.policySummary.beneficiaries"
					[nzFrontPagination]="false">
					<thead>
						<tr>
							<th>Type</th>
							<th>Name</th>
							<th>Surname</th>
							<th>ID Number</th>
							<th>Date Of Birth</th>
							<th>Bank</th>
							<th>Amount</th>
							<th>Payment Date</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let beneficiary of ticket.policySummary.beneficiaries">
							<td>{{beneficiary.type}}</td>
							<td>{{beneficiary.name}}</td>
							<td>{{beneficiary.surname}}</td>
							<td>{{beneficiary.idNumber}}</td>
							<td>{{beneficiary.dateOfBirth}}</td>
							<td>
								<ng-container *ngIf="!beneficiary.bankAccount">
									None
								</ng-container>
								<ng-container *ngIf="beneficiary.bankAccount">
									<div class="summary-field">
										<span class="summary-field__label">Bank
										</span>
										<span class="summary-field__value">{{
											beneficiary.bankAccount.bank.name
											}}</span>
									</div>
									<div class="summary-field">
										<span class="summary-field__label">Account
											Number</span>
										<span class="summary-field__value">{{
											beneficiary.bankAccount.accountNumber
											}}</span>
									</div>
								</ng-container>
							</td>
							<td>{{beneficiary.benefitAmount | currency: 'ZAR' :
								'symbol-narrow'}}</td>
							<td>{{(beneficiary.paymentDate | date) ?? '-'}}</td>
						</tr>
					</tbody>
				</nz-table>
			</div>
		</div>
	</nz-card>

	<ng-container *ngIf="!step.isCurrentState">
		<app-dft-card *ngFor="let section of step.sections" [title]="section.label" [readonly]="true"
			[dynamicForm]="dynamicForms![section.id]">
		</app-dft-card>
		<app-ticket-form-section-images [ticket]="ticket" [step]="step"></app-ticket-form-section-images>
	</ng-container>

	<ng-container *ngIf="step.isCurrentState">
		<div class="row">
			<div class="col">
				<app-dft-card *ngFor="let section of step.sections" [title]="section.label"
					[readonly]="!ticket.hasAccess || !step.isCurrentState"
					[dynamicForm]="dynamicForms![section.id]" [allFormControls]="allFormControls"
					[allForms]="allForms" [masterForm]="masterForm">
				</app-dft-card>
				<nz-card nzTitle="Questionnaire" class="mt-2" *ngIf="ticket.questionnaireTemplate">
					<table class="table table-striped table-sm">
						<thead>
							<tr class="table-dark">
								<th>Name</th>
								<th>Created</th>
								<th>Progress</th>
								<th>Status</th>
								<th>Last Updated</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let questionnaire of ticket.questionnaires"
								(dblclick)="openQuestionnaire(questionnaire)">
								<td>{{questionnaire.name}}</td>
								<td>{{questionnaire.createdAt|date}}</td>
								<td>
									<div class="progress position-relative"
										role="progressbar">
										<div class="progress-bar text-bg-info"
											[style]="'width: ' + questionnaire.progress + '%'">
										</div>
										<span
											class="position-absolute top-50 start-50 translate-middle w-100 text-center">
											{{ questionnaire.progress / 100
											| percent:'1.0-0' }}
										</span>
									</div>
								</td>
								<td>{{questionnaire.progress == 100 ? 'Completed' : 'Not
									Completed'}}</td>
								<td>{{questionnaire.lastActionedAt|date:'yyyy-MM-dd
									HH:mm:ss'}}</td>
							</tr>
						</tbody>
					</table>
					<button nz-button nzType="dashed" class="float-start"
						*ngIf="ticket.questionnaireEditable" (click)="newQuestionnaire()">+ Add
						Questionnaire</button>
					<button nz-button nzType="dashed" class="float-end"
						*ngIf="ticket.questionnaireEditable" (click)="viewQuestionnaires()">View
						Questionnaire</button>
				</nz-card>

				<app-ticket-form-section-images [ticket]="ticket" [step]="step"
					[formControls]="allFormControls" [readonly]="!ticket.hasAccess"
					[additionalFileFormGroup]="additionalFilesForm">
				</app-ticket-form-section-images>
				<app-ticket-form-section-operations [ticket]="ticket" [step]="step"
					[formControls]="allFormControls"
					[readonly]="!ticket.hasAccess || !step.isCurrentState"
					[masterForm]="masterForm">
				</app-ticket-form-section-operations>
			</div>
			<div class="col-4" *ngIf="history">
				<nz-card nzSize="small" nzTitle="Captured Fields" class="mt-2">
					<ul class="captured-fields" *ngIf="history.fields?.length; else noFields">
						<ng-container *ngFor="let field of history.fields">
							<li *ngIf="canShowCapturedField(field)">
								<span class="label">{{ field.inputLabel }}</span>
								<span class="value" [ngSwitch]="field.dataType">
									<ng-container *ngSwitchCase="'ICD10'">
										<ng-container
											*ngIf="field.inputValueObject">
											<div class="icd10-option">
												<div
													class="icd10-option__codes">
													<span
														class="icd10-option__code">{{
														field.inputValueObject.icd_10_code
														}}</span>
													<span
														class="icd10-option__separator">·</span>
													<span
														class="icd10-option__sub-code">{{
														field.inputValueObject.icd_10_3_code
														}}</span>
													<span
														class="icd10-option__separator">·</span>
													<span
														class="icd10-option__group">{{
														field.inputValueObject.groupCode
														}}</span>
												</div>
												<div
													class="icd10-option__desc">
													{{
													field.inputValueObject.whoFullDescription
													||
													field.inputValueObject.icd_10_3_code_desc
													}}</div>
												<div
													class="icd10-option__group-desc">
													{{
													field.inputValueObject.groupDescription
													}}</div>
											</div>
										</ng-container>
										<ng-container
											*ngIf="!field.inputValueObject">
											{{field.inputValue}}
										</ng-container>
									</ng-container>
									<ng-container
										*ngSwitchDefault>{{field.inputValue}}</ng-container>
								</span>
							</li>
						</ng-container>
					</ul>
					<ng-template #noFields>
						<nz-empty nzNotFoundContent="No fields captured"></nz-empty>
					</ng-template>
				</nz-card>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col" *ngIf="ticket.hasAccess">
				<div class="d-flex justify-content-between align-items-start w-100">

					<div class="d-flex flex-wrap align-items-start gap-3">
						<ng-container *ngFor="let button of visibleLeftButtons">
							<button nz-button nzSize="large"
								[nzType]="getNzButtonType(button)"
								(click)="button.requiredValidForm == true && masterForm.valid == false ? highlightInvalidFields() : buttonClick(button)"
								class="mb-2">

								<nz-icon *ngIf="button.requiredValidForm == true && masterForm.valid == false"
									[nzType]="'warning'" nzTheme="twotone"
									nzTwotoneColor="#eb2f96">
								</nz-icon>

								{{ button.label }}
							</button>
						</ng-container>
					</div>

					<div class="d-flex flex-wrap align-items-start justify-content-end gap-3">
						<ng-container *ngFor="let button of visibleRightButtons">
							<button nz-button nzSize="large"
								[nzType]="getNzButtonType(button)"
								(click)="button.requiredValidForm == true && masterForm.valid == false ? highlightInvalidFields() : buttonClick(button)"
								class="mb-2">

								<nz-icon *ngIf="button.requiredValidForm == true && masterForm.valid == false"
									[nzType]="'warning'" nzTheme="twotone"
									nzTwotoneColor="#eb2f96">
								</nz-icon>

								{{ button.label }}
							</button>
						</ng-container>
					</div>

				</div>
			</div>

			<div class="col" *ngIf="!ticket.hasAccess && ticket.id">
				<button nz-button nzSize="large" nzType="default" (click)="doReadOnlySave()"
					class="me-2 float-end">
					Save Operational Notes and Additional Files
				</button>
			</div>
		</div>
	</ng-container>
</div>


<ng-template #ticketHistoryModalTitle>
	<div style="display: flex; align-items: center; justify-content: space-between; padding-right: 40px;">
		<span>Ticket History</span>
		<button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Open in new window"
			(click)="openInNewWindow()">
			<span nz-icon nzType="fullscreen" nzTheme="outline"></span>
		</button>
	</div>
</ng-template>